import { Outlet, Link } from 'react-router-dom';
import { BreachCraftLogo } from '@/components/ui/logo';
import { ParticleField } from '@/components/effects/ParticleField';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-bc-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-bc-black via-bc-navy to-bc-black" />

      {/* Circuit pattern overlay */}
      <div className="absolute inset-0 circuit-bg opacity-[0.18]" />

      {/* Scanline overlay */}
      <div className="absolute inset-0 scanlines" />

      {/* Animated gradient orbs */}
      <div className="absolute top-1/4 -right-1/4 w-[500px] h-[500px] bg-bc-teal/10 rounded-full blur-[120px] animate-pulse" />
      <div className="absolute bottom-1/4 -left-1/4 w-[350px] h-[350px] bg-bc-teal/8 rounded-full blur-[100px] animate-pulse" style={{ animationDelay: '1s' }} />

      {/* Particle field animation */}
      <ParticleField
        particleCount={40}
        maxConnections={3}
        connectionDistance={120}
        color="#00B4A6"
      />

      {/* Header */}
      <header className="relative z-10 py-4">
        <div className="container max-w-site mx-auto px-[4vw]">
          <Link
            to="/login"
            className="flex items-center gap-3 text-white font-bold text-lg no-underline hover:no-underline"
          >
            <BreachCraftLogo className="w-10 h-10" />
            <span>Partner Portal</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main id="main-content" className="relative z-10 flex-1 flex items-center justify-center py-12 px-4">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="relative z-10 bg-bc-black/80 text-gray-400 py-8 backdrop-blur-sm">
        <div className="container max-w-site mx-auto px-[4vw] text-center text-sm">
          <p className="mb-2">
            &copy; {new Date().getFullYear()} Breach Craft LLC. All rights reserved.
          </p>
          <p>
            <Link to="/privacy" className="text-gray-300 hover:text-bc-teal">
              Privacy Policy
            </Link>
          </p>
        </div>
      </footer>
    </div>
  );
}
